/** @jsxImportSource theme-ui */
import { Spinner } from 'theme-ui';
import React from 'react';
import { Formik } from 'formik';
import { useGetIncentiveActionsQuery, usePostActionsMutation } from '@/store/apiService';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ActionForm, initialValues } from './ActionForm';

type Props = {};

const CreateAction: React.FC<Props> = (props: Props) => {
    const [createAction, createActionState] = usePostActionsMutation();
    const actions = useGetIncentiveActionsQuery({});
    const navigate = useNavigate();

    if (!actions.data) {
        return <Spinner size={16}></Spinner>;
    }

    return (
        <>
            <Formik
                initialValues={initialValues}
                enableReinitialize
                onSubmit={(values, { resetForm, setErrors, setSubmitting }) => {
                    createAction(values)
                        .unwrap()
                        .then((res) => {
                            navigate(`/actions`);
                        })
                        .catch((err) => {
                            setSubmitting(false);
                            toast.error(err.data, { autoClose: 5000 });
                        });
                }}
            >
                {(formProps) => {
                    return (
                        <>
                            <ActionForm additionalErrors={createActionState.error} {...formProps} />
                        </>
                    );
                }}
            </Formik>
        </>
    );
};

export default CreateAction;
